import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import iconRetina from 'leaflet/dist/images/marker-icon-2x.png';

/** Helpers extraits de WorldMap.tsx pour respecter la limite de 500 lignes par fichier. */

export const INTERVENTION_MAP_ICON_URL = '/images/intervention-default.png';

export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export const DefaultIcon = L.icon({
  iconUrl: icon,
  iconRetinaUrl: iconRetina,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41],
});

export function liveVehicleStatusStyle(statusRaw: string): { fill: string; stroke: string } {
  const s = String(statusRaw || '').toLowerCase();
  if (s === 'retour_disponible_radio' || s === 'disponible_radio') return { fill: '#22c55e', stroke: '#dcfce7' };
  if (
    s === 'retour_disponible_hors_secteur' ||
    s === 'retour_non_operationnel' ||
    s === 'disponible_hors_secteur' ||
    s === 'retour_hors_secteur'
  ) {
    return { fill: '#f59e0b', stroke: '#fef3c7' };
  }
  if (s === 'transport_hopital' || s === 'arrive_hopital') {
    return { fill: '#0ea5e9', stroke: '#e0f2fe' };
  }
  if (s === 'sur_les_lieux' || s === 'sur_place') return { fill: '#10b981', stroke: '#d1fae5' };
  if (s === 'en_alerte' || s === 'prealerte') return { fill: '#eab308', stroke: '#fef9c3' };
  return { fill: '#f43f5e', stroke: '#ffe4e6' };
}

export function createLiveVehicleDefaultIcon(statusRaw: string): L.DivIcon {
  const color = liveVehicleStatusStyle(statusRaw);
  return L.divIcon({
    className: 'live-vehicle-marker',
    html: `
      <div style="
        width: 28px;
        height: 28px;
        border-radius: 999px;
        border: 2px solid ${color.stroke};
        background: ${color.fill};
        box-shadow: 0 3px 10px rgba(0,0,0,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-size: 15px;
        line-height: 1;
      ">
        🚒
      </div>
    `,
    iconSize: [28, 28],
    iconAnchor: [14, 14],
    tooltipAnchor: [0, -12],
  });
}

export function formatMmSs(totalSecRaw: number | null | undefined): string {
  const total = Math.max(0, Math.floor(Number(totalSecRaw || 0)));
  const mm = Math.floor(total / 60);
  const ss = total % 60;
  return `${String(mm).padStart(2, '0')}:${String(ss).padStart(2, '0')}`;
}
